
import { FormControl, InputLabel, Select } from "@mui/material";
import React, { useState } from "react"
import { useTranslation } from "react-i18next";
import countryList from 'react-select-country-list'

export interface CountryDto {
    name: string,
    code: string,
    capital?: string,
    region?: string,
    latlng?: number[];
}
export interface CountryMinimalDto {
    label: string,
    value: string,
}
export interface CountryPickerProps {
    className?: any,
    defaultCountry: string,
    label: string,
    onSelected: (dto: CountryDto) => void
    disabled?: boolean
}


export const CountryPicker = (props: CountryPickerProps) => {

    const [t] = useTranslation("common");
    const options = React.useMemo(() => countryList().getData() as CountryMinimalDto[], [])
    const handleSelect = (e: any) => {
        props.onSelected({ name: e.target.value, code: e.target.value });
    }
    return <React.Fragment>
        <FormControl variant="outlined" className={props.className}>
            <InputLabel htmlFor="countryPicker">{props.label}</InputLabel>
            <Select
            style={{marginTop:"16px"}}
                native
                disabled={props.disabled}
                label={props.label}
                onChange={handleSelect}
                defaultValue={props.defaultCountry}
                id="countryPicker"
            >
                {options.map((el) => {
                    return <option value={el.value}>{el.label}</option >
                })}
            </Select>
        </FormControl>
    </React.Fragment >
}